var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_911_49)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_911_49",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.95 0H0V24H23.95V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_911_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.92 11.06C23.47 4.83 18.06 -0.13 11.8 -4.37256e-07C8.08 0.0499996 4.44 1.82 2.15 5.09C1.45 6.08 1.69 7.45 2.68 8.15C3.67 8.85 5.04 8.61 5.74 7.62C7.59 4.99 10.81 3.89 13.75 4.61C17.08 5.38 19.6 8.56 19.56 12C19.56 14.2 18.6 16.3 16.93 17.75C16.01 18.55 15.92 19.93 16.71 20.85C17.51 21.77 18.89 21.86 19.81 21.07C22.68 18.59 24.21 14.84 23.91 11.07L23.92 11.06Z",
    fill: "url(#paint0_linear_911_49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.48 16.62V17.39C12.48 17.69 12.24 17.94 11.93 17.94C11.62 17.94 11.38 17.7 11.38 17.39V16.63C10.27 16.55 9.38 16.17 8.68 15.64C8.5 15.5 8.38 15.27 8.38 15.02C8.38 14.6 8.72 14.26 9.15 14.26C9.31 14.26 9.48 14.31 9.61 14.41C10.11 14.78 10.69 15.06 11.39 15.17V12.52C9.97 12.17 8.48 11.64 8.48 9.86C8.48 8.46 9.62 7.35 11.39 7.2V6.4C11.39 6.1 11.63 5.85 11.94 5.85C12.25 5.85 12.49 6.09 12.49 6.4V7.22C13.33 7.3 14.05 7.56 14.7 8C14.89 8.14 15.03 8.37 15.03 8.63C15.03 9.04 14.69 9.39 14.27 9.39C14.11 9.39 13.96 9.34 13.85 9.25C13.43 8.96 12.97 8.78 12.49 8.69V11.05C13.92 11.43 15.46 11.97 15.46 13.81C15.45 15.2 14.54 16.41 12.49 16.61L12.48 16.62ZM11.38 10.77V8.63C10.6 8.71 10.11 9.14 10.11 9.75C10.11 10.29 10.65 10.57 11.38 10.77ZM13.81 13.97C13.81 13.34 13.25 13.05 12.48 12.82V15.18C13.43 15.04 13.81 14.49 13.81 13.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.24 15.85C20.25 15.15 18.88 15.39 18.18 16.38C17.01 18.04 15.26 19.15 13.26 19.5C11.26 19.85 9.24 19.39 7.58 18.22C5.78 16.95 4.61 14.96 4.39 12.76C4.36 12.44 4.25 12.14 4.1 11.87C4.14 12.03 4.17 12.19 4.17 12.36C4.17 13.46 3.28 14.35 2.18 14.35C1.08 14.35 0.189998 13.46 0.189998 12.36C0.189998 12.25 0.209998 12.14 0.219998 12.03C0.0499985 12.38 -0.0300015 12.78 0.00999846 13.2C0.359998 16.66 2.19 19.8 5.04 21.81C7.09 23.25 9.48 24 11.93 24C12.62 24 13.31 23.95 14.02 23.82C17.18 23.28 19.93 21.53 21.78 18.91C22.48 17.92 22.24 16.55 21.25 15.85H21.24Z",
    fill: "url(#paint1_linear_911_49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.18 14.59C0.9 14.59 0 13.65 0 12.38C0 11.11 0.9 10.17 2.18 10.17C3.46 10.17 4.36 11.11 4.36 12.38C4.36 13.65 3.46 14.59 2.18 14.59ZM2.18 13.92C3.04 13.92 3.6 13.26 3.6 12.38C3.6 11.5 3.05 10.84 2.18 10.84C1.31 10.84 0.76 11.51 0.76 12.38C0.76 13.25 1.32 13.92 2.18 13.92Z",
    fill: "url(#paint2_linear_911_49)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_911_49",
    x1: 1.22,
    y1: 10.8,
    x2: 19.67,
    y2: 10.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#7933D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_911_49",
    x1: -0.830002,
    y1: 17.94,
    x2: 20.58,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2B58EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7933D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_911_49",
    x1: 2.21,
    y1: 14.29,
    x2: 2.16,
    y2: 10.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2B58EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_911_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.95,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsc);
export default __webpack_public_path__ + "static/media/usc.e8f697a6d9bf250f06d06eac3d6b3db0.svg";
export { ForwardRef as ReactComponent };